import {acceptableUsePolicy} from "../../data/acceptableUsePolicy";
import LegalAccordion from "../../components/LegalAccordion";
import "./AcceptableUsePage.css";


const AcceptableUsePage = () => {

    return (

        <section className="acceptable-page">


            <div className="acceptable-hero">

                <span>
                    Legal
                </span>


                <h1>
                    Acceptable Use Policy
                </h1>


                <p>
                    Guidelines for responsible and secure use of
                    Magyne products and services.
                </p>


                <div className="effective-date">
                    Effective Date: 01 June, 2026
                </div>

            </div>



            <div className="acceptable-container">


                {
                    acceptableUsePolicy.map(section => (

                        <LegalAccordion
                            key={section.id}
                            section={section}
                        />

                    ))
                }


            </div>


        </section>

    );

};


export default AcceptableUsePage;